module.exports = __webpack_public_path__ + "img/persona2.c7a05e08.jpg";